// extracted by mini-css-extract-plugin
export default {"app":"app_app__ppOMv","errorMessage":"app_errorMessage__oGK4H"};